import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-design-issue-all-form',
  templateUrl: './project-design-issue-all-form.component.html',
  styleUrls: ['./project-design-issue-all-form.component.css']
})
export class ProjectDesignIssueAllFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/technical/project-design-issue-total/project-design-issue-all-form/project-design-issue-all-form.component.ts